import { render } from "./NavigationTabVertical.vue?vue&type=template&id=353367c5"
import script from "./NavigationTabVertical.vue?vue&type=script&lang=ts"
export * from "./NavigationTabVertical.vue?vue&type=script&lang=ts"
script.render = render

export default script